<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-26 14:15:50
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-05-20 00:33:44
 * @FilePath: /goldenSalesMobile/src/views/RefundOrder/OrderList/index.vue
 * @Description: 退单订单列表
-->
<template>
  <div class='page-container'>
    <div class="tab-list">
      <van-list
              v-model="loading"
              :error.sync="loadError"
              :finished="finished"
              :offset="30"
              error-text="请求失败，点击重新加载"
              finished-text="没有更多了"
              @load="onLoad"
      >
        <div
                class="order-item"
                v-for="(subItem, subIndex) in coupons"
                :key="subIndex"
        >
          <div class="first-line">
            <span>券号：{{ subItem.CouponNumber }}</span>
            <span :class="'status-style-' + subItem.CouponHistoryStatus.Id">
              <a>{{ subItem.CouponHistoryStatus.Name }}</a>
            </span>
          </div>
          <div class="second-line">
            <p style="font-size: large;color: #FF9F00">{{subItem.CouponName}}</p>
            <p>{{formatRuleType(subItem.CouponRuleTypeId, subItem.CouponPrice, subItem.CouponSale)}}</p>
            <p>有效期：{{formatDate(subItem.StartTime)}} - {{formatDate(subItem.EndTime)}}</p>
            <p>可用时段：{{subItem.StartTimeOfDay}} - {{subItem.EndTimeOfDay}}</p>
            <p>可用星期：{{formatWeekDay(subItem.WeekDays)}}</p>
          </div>
<!--          <div class="last-line">-->
<!--            <p>领取时间：{{ subItem.Creation }}</p>-->
<!--&lt;!&ndash;            <p v-if="subItem.Creation">使用时间：{{ subItem.Creation }}</p>&ndash;&gt;-->
<!--          </div>-->
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
  import { getUserCouponList } from '@/api/coupon'
  export default {
    data() {
      return {
        coupons: [],
        loading: false,
        loadError: false,
        finished: false,
        pageIndex: 0,
        pageSize: 10,
      }
    },

    created() {

    },

    methods: {
      // 上拉加载
      // TODO tab切换之后上拉加载为何会连续触发
      onLoad() {
// console.log('上拉加载退单列表')
        this.pageIndex++
        this.getUserCouponList()
      },

      // 加载优惠券列表
      getUserCouponList() {
        getUserCouponList({
          query: {},
          pager: {pageindex: this.pageIndex, pagesize: this.pageSize}
        })
        .then(res => {
// console.log(res)
          let data = res.Items
          if (data instanceof Array) {
            data.map(m => {
              this.coupons.push(m)
            })
            // 没有更多数据时结束上拉加载事件
            if (data.length < this.pageSize || data.length === 0) {
              this.finished = true
            }
            // 加载结束
            this.loading = false
          }
        })
        .catch(err => {
// console.log(err)
          this.loadError = true
          this.loading = false
        })
      },

      formatDate(date) {
        date = new Date(date);
        return `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate() + 1}`;
      },

      formatWeekDay(weekDay) {
        return weekDay.replace('Monday', '星期一')
                .replace('Tuesday', '星期二')
                .replace('Wednesday', '星期三')
                .replace('Thursday', '星期四')
                .replace('Friday', '星期五')
                .replace('Saturday', '星期六')
                .replace('Sunday', '星期日')
      },

      formatRuleType(ruleTypeId, price, sale){
        let subname = '';
        if(ruleTypeId === 0)
        {
          subname = `满${price}减${sale}`
        }
        else if(ruleTypeId === 1)
        {
          let count = price.toString()
          if(count.length >1 && count.substr(1,1) == '0')
          {
            count = count.substr(0,1)
          }
          subname = `满${price}打${count}折`
        }
        return subname
      },

    }
  }
</script>

<style lang='scss' scoped>
  .page-container {
    background: $blockBgColor;

    .tab-list {
      margin-bottom: 100px;

      &::v-deep .van-list {
        @include border-box(0 20px);
      }

      .order-item {
        width: 100%;
        box-shadow: 0px 0px 14px 0px rgba(182,182,182,0.5);;
        border-radius: 16px;
        margin-top: 20px;
        overflow: hidden;

        >div {
          @include border-box(0 20px);
        }

        .first-line {
          @include flex-box(space-between);
          height: 84px;
          border-bottom: 1px solid #F7F7F7;

          >span:first-child {
            line-height: 40px;
            font-size: 28px;
            font-weight: 500;
            color: $secondFontColor;
          }

          >span:last-child {
            width: 112px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            font-size: 24px;
            font-weight: 500;
            color:#fff;
            border-radius: 8px;
            transform: skewX(-30deg);

            >a {
              display: inline-block;
              transform: skewX(30deg);
            }

            &.status-style-0 {
              background: linear-gradient(to right, #28A2FF, #76CDFF);
            }

            &.status-style-1 {
              background: linear-gradient(to right, #B5BBD0, #D7DDEA);
            }

            &.status-style-2 {
              background: linear-gradient(to right, #FA9B00, #FBCA39);
            }
          }
        }

        .second-line {
          margin: 20px 0;

          >p {
            @include multi-line-ellipsis(2);
            font-size: 30px;
            font-weight: 500;
            color: $secondFontColor;
            line-height: 42px;
          }
        }

        .last-line {
          @include flex-box(space-between);
          margin-bottom: 22px;

          >span:first-child {
            line-height:40px;
            font-size: 28px;
            color: $baseFontColor;
          }

          >span:last-child {
            line-height: 44px;
            font-size: 32px;
            font-weight: 600;
            color:#FE4600;
          }
        }
      }
    }
  }
</style>
